import { QUERY_KEYS } from 'api/query-keys';
import { CreateMultiDayShiftRequestDto } from 'api/services/shift/shift-service.dto';
import { useMutation, useQueryClient } from 'react-query';
import { sharedShiftService } from 'api/services';
import { useSiteDetection } from 'shared/hooks';
import { CreateMultiDayShiftMutationOptions } from './use-create-multi-day-shift.types';

export const useCreateMultiDayShift = () => {
  const queryClient = useQueryClient();
  const { site } = useSiteDetection();

  const mutationFn = async (shift: CreateMultiDayShiftRequestDto) =>
    await sharedShiftService.createMultiDayShift(site, shift);
  const options: CreateMultiDayShiftMutationOptions = {
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.shifts());
    },
  };

  return useMutation(mutationFn, options);
};
